import { render, staticRenderFns } from "./listagemComprovativos.vue?vue&type=template&id=61e91d9c&"
import script from "./listagemComprovativos.vue?vue&type=script&lang=js&"
export * from "./listagemComprovativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports